// Sends the browser to a Stripe page (kept separate so tests can replace it).
export function openPaymentPage(url) {
  window.location.assign(url);
}
